// extracted by mini-css-extract-plugin
export var container = "_hk-1";
export var cornerButtonContainer = "_hk-6";
export var disabled = "_hk-2";
export var dragActive = "_hk-3";
export var fileContainer = "_hk-5";
export var hiddenInput = "_hk-4";
export var widthContainer = "_hk-0";